import { useMutation } from "@tanstack/react-query";
import { z } from "zod";

import { useAxios } from "./useApiQuery";

const responseSchema = z.discriminatedUnion("success", [
  z.object({
    success: z.literal(true),
    termsOfServiceAcceptanceTimestamp: z.string(),
  }),
  z.object({
    success: z.literal(false),
  }),
]);

export default function useAcceptTermsOfServiceMutation(args?: {
  onSuccess?: (data: { termsOfServiceAcceptanceTimestamp: string }) => void;
  onFailure?: () => void;
}) {
  const acceptTermsOfService = useAxios<unknown>({
    path: "/user/accept-terms-of-service",
    config: { method: "post" },
  });

  const mutation = useMutation({
    async mutationFn() {
      return responseSchema.parseAsync(await acceptTermsOfService());
    },
    onSettled(data) {
      if (data?.success) {
        args?.onSuccess?.(data);
      } else {
        args?.onFailure?.();
      }
    },
  });

  return mutation;
}
